<template>
  <!-- needed ref="thead" to eliminate the vuesax error -->
  <tbody ref="thead">
    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in rows">
      <vs-td>
        <vs-chip :color="getOrderStatusColor(tr.visits && tr.visits.length > 0 ? tr.visits[tr.visits.length-1].status : '')">
          {{ (tr.visits && tr.visits.length > 0 ? tr.visits[tr.visits.length-1].status : '') }}</vs-chip>
      </vs-td>
      <vs-td>
        <h5 class="product-category">{{ tr.firstName }} {{ tr.lastName }}</h5>
      </vs-td>
      <vs-td>
        <h5 class="product-category">{{ (tr.contactType || {}).name || 'N/a' }}</h5>
      </vs-td>
      <vs-td>
        <p class="product-price">{{ tr.mobile }}</p>
      </vs-td>
      <vs-td>
        <p class="product-price">{{ tr.email }}</p>
      </vs-td>
      <vs-td>
        <p class="product-price">{{ tr.companyName }}</p>
      </vs-td>
      <vs-td class="whitespace-no-wrap">
        <router-link :to="{ name: 'edit-contact', params: { id: tr.id } }">
          <feather-icon
            icon="EditIcon"
            svgClasses="w-5 h-5 hover:text-primary stroke-current"
          />
        </router-link>
        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteItem(tr.id)" />
      </vs-td>
    </vs-tr>
  </tbody>
</template>

<script>
export default {
  props: ['rows', 'methods'],
  methods: {
    clicktr (tr) {
      this.$router.push({ name: 'edit-contact', params: { id: tr.id } })
    }, // needed to eliminate the error this.$parent.clicktr
    async deleteItem (id) {
      await this.$store.dispatch('visitManagement/deleteContactById', id);
      if (this.methods) {
        const { onDelete } = this.methods;
        onDelete(id);
      }
    }
  }
}
</script>
